import axios from './axiosService';
import {isObject, keys, orderBy} from 'lodash';


/**
 * MLD-5518
 */
export default {
  getPermissionKeyNames() {
    return orderBy(keys(this.getDefaultPermissions()).filter(key => key.startsWith('can_')));
  },
  getDefaultPermissions() {
    if (isObject(window.ML) && isObject(window.ML.user) && isObject(window.ML.user.permissions)) {
      return window.ML.user.permissions;
    }
    return { // MLD-5518
      can_edit_brands: false,
      can_edit_devices: false,
      can_edit_email_templates: false,
      can_test_email_templates: false, // MLD-4550
      can_edit_events: false,
      can_edit_faxes: false,
      can_edit_files: false,
      can_edit_folders: false,
      can_edit_forms: false,
      can_edit_groups: false,
      can_edit_labels: false,
      can_edit_messages: false,
      can_edit_metabase_permissions: false,
      can_edit_presentations: false,
      can_edit_products: false,
      can_edit_subscribers: false,
      can_edit_team: false,
      can_edit_territories: false,
      can_edit_user_contacts: false,
      can_edit_users: false,
      can_edit_webhooks: false,
      can_export_data: false,
    }
  },
  getPermissions() {
    return axios.get(`/api/user/permissions`)
      .then(response => response.data)
  },
  getPermissionsFor(userID) {
    return axios.get(`/api/users/${userID}/permissions`)
      .then(response => response.data)
  }
}
